<p class="nx-margin-left-s nx-margin-top-s">
  <span class="contact-head">{{model.firstName}} {{model.lastName}}</span> <br>
  <span class="contact-body">{{model.email}}</span> <br>
  <span class="contact-body">{{model.phone }}</span> <br>
</p>
